module.exports = __webpack_public_path__ + "img/puzzle8_8.541d95b4.jpg";